// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1p-0 {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n", ""]);
// Exports
export var closeButton = "_1p-0";
export default ___CSS_LOADER_EXPORT___;
